import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/helpdesk/customers')({
  component: () => <Outlet />,
})